var exports = {
  "f4": "Highlight__eGDVdv",
  "jF": "River__BNVuHy",
  "fh": "Cell__MAo5j7",
  "hE": "Title__B3hll_",
  "HY": "EyebrowWrapper__p09Dub",
  "tK": "SubTitle__FmAUVe",
  "Cj": "EyebrowMobile__POXsdD",
  "IB": "EyebrowDesktop__tVWT20",
  "UC": "Content__QsJuKm",
  "VY": "Description__8qQr03",
  "mh": "MediaWrapper__CIN89L",
};

module.exports = exports;
